import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import styles from '~modules/downloads/Downloads.module.css';

export default function ModuleDownloadsWithDescription({
  data,
  editing,
  className,
  onChange,
  onAddNewChild,
  origData,
  stable,
}: IEntityComponentProps) {
  const downloadIds = getRelatedEntityIds(data, 'field_items');

  if (!data) {
    return null;
  }

  const id = getModuleUrlIdFromData(data.id, data.type);

  const clsModule = clsx({ ...className?.module }, 'relative');
  const clsContainer = clsx('px-0 relative', { ...className?.container });
  const clsHeader = clsx('c-module__header row');
  const clsHeaderContent = 'col col-sm-12';
  const clsBody = clsx('c-module__content row d-flex flex-wrap');
  const clsBodyContent = clsx('u-margin-top-sm u-margin-bottom-lg o-field-text col col-sm-12');
  const clsList = clsx('u-margin-top-md col col-sm-12');

  return (
    <div className={clsModule} id={id}>
      <div className={clsContainer}>
        <div className={clsHeader}>
          <div className={clsHeaderContent}>
            <EditableField
              hide={data.attributes.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={data.attributes.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
        </div>
        <div className={clsBody}>
          {data.attributes.field_text && !data.attributes.field_hide_text ? (
            <div className={clsBodyContent}>
              <EditableField
                entityType={data.type}
                fieldName="attributes.field_text.value"
                data={data.attributes.field_text.value}
                editing={editing}
                onChange={onChange}
              />
            </div>
          ) : null}

          <div className={clsList}>
            <div className={clsx(styles.list, 'downloads-list')}>
              {downloadIds.map((id, i) => (
                <DraggableModuleContainer
                  parentIsStable={stable}
                  index={i}
                  key={id}
                  entityId={id}
                  parentContext={data.id}
                  parentType={data.type}
                  fieldName="relationships.field_items.data"
                  siblingsLength={downloadIds.length - 1}
                  canMove={editing}
                />
              ))}
            </div>

            {editing && (
              <div>
                <AddLink
                  onClick={() =>
                    onAddNewChild({
                      id: origData,
                      fieldName: 'relationships.field_items.data',
                      templateType: 'paragraph--file',
                    })
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
